import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TicketValidityFacade {
    private readonly defaultTicketRangeTotalDays: number = 1;

    private _jointTicketRangeTotalDays$ = new BehaviorSubject<number>(this.defaultTicketRangeTotalDays);

    get jointTicketRangeTotalDays$(): Observable<number> {
        return this._jointTicketRangeTotalDays$.asObservable();
    }

    updateJointTicketRangeTotalDays(timeDiff: number): void {
        const totalDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        this._jointTicketRangeTotalDays$.next(totalDays);
    }

    reset(): void {
        this._jointTicketRangeTotalDays$.next(this.defaultTicketRangeTotalDays);
    }
}
